import React from 'react';
import {
    DataGrid,
    DataGridToolbar,
    DataGridToolbarButtonsGroup,
    DataGridToolbarButtonRefresh,
    DataGridToolbarButtonImport,
    DataGridToolbarCheckBox
} from '../BaseComponents';

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';

const Toolbar = () => {
    return (
        <DataGridToolbar
            title="Spin Program"
        >
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarCheckBox
                    id="showAllCheckBox"
                    filterOrder="1"
                    filterWhenChecked="all"
                    filterWhenUnchecked="enabled"
                    caption="Show Deleted"
                />
                <DataGridToolbarButtonRefresh />
                <DataGridToolbarButtonImport />
            </DataGridToolbarButtonsGroup>
        </DataGridToolbar>
    );
};

const SpinProgram = () => {
    return (
        <DataGrid model='spinProgram'>
            <Toolbar />
        </DataGrid>
    );
};

export default withAITracking(ai.reactPlugin, SpinProgram, "SpinProgram");